const carrotQuestionPlugin = defineNuxtPlugin(() => {
  const { isSportbenefitBrand, carrotAppId } = useRuntimeConfig().public;

  if (window.carrotquest || isSportbenefitBrand || !carrotAppId) {
    return;
  }
  
  const script = document.createElement("script");

  script.type = "text/javascript";
  script.async = true;
  script.src = "https://cdn.carrotquest.app/api.min.js";

  window.carrotquest = {};
  window.carrotquestasync = [];

  const createMethod = (method: string) => {
    return function (...args: unknown[]) {
      window.carrotquestasync.push(method, args);
    };
  };

  const methods = [
    "connect",
    "track",
    "identify",
    "auth",
    "onReady",
    "addCallback",
    "removeCallback",
    "trackMessageInteraction",
  ];

  methods.forEach((method) => {
    window.carrotquest[method] = createMethod(method);
  });

  window.carrotquest.settings = {};

  script.onerror = () => {
    console.error("[Carrot quest] Failed to load the chat script:", script.src);
  };

  window.carrotquest.connect(carrotAppId);
  document.head.appendChild(script);
});

export default carrotQuestionPlugin;